var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-content"}},[_c('navBar'),_c('SideMenu'),(_vm.arrMaintenance.length > 0)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.arrMaintenance[0].VerValue)}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }